const enum Role {
  SuperAdmin = 'superAdmin',
  Admin = 'admin',
  BillingManager = 'billingManager',
  TeamMember = 'teamMember',
  Guest = 'guest',
}

export default Role;
